// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"112":"build-glob","220":"build-doc","839":"build-map"}[chunkId] + "-legacy." + {"112":"fb959d59","220":"6ace49e7","839":"07d06ccc"}[chunkId] + ".js";
};